import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import * as chatActions from 'react/redux/actions/chat';
import ExpandingTextarea from "react/elements/ExpandingTextarea";

class EditingMessageComponent extends React.Component {

	constructor(props) {
		super(props);
		this.onChange = this.onChange.bind(this);
	}

	onChange(event) {
		const { chatMessageEditTextChange } = this.props;
		chatMessageEditTextChange(event.target.value);
	}

	render() {
		const { onKeyDown, editingChatMessageText } = this.props;
		return (
			<ExpandingTextarea
				autoFocus
				maxLength='300'
				onChange={this.onChange}
				onKeyDown={onKeyDown}
				className='message editing'
				value={editingChatMessageText}
				// dangerouslySetInnerHTML={{ __html: this.state.html }}
			/>
		);
	}
}

function mapStateToProps(state) {
	return {
		editingChatMessageText: state.chat.editingChatMessageText,
	};
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators({
		...chatActions,
	}, dispatch);
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(EditingMessageComponent);